import { render, staticRenderFns } from "./roleTableModal.vue?vue&type=template&id=223f2ab0&scoped=true&"
import script from "./roleTableModal.vue?vue&type=script&lang=js&"
export * from "./roleTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f2ab0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223f2ab0')) {
      api.createRecord('223f2ab0', component.options)
    } else {
      api.reload('223f2ab0', component.options)
    }
    module.hot.accept("./roleTableModal.vue?vue&type=template&id=223f2ab0&scoped=true&", function () {
      api.rerender('223f2ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/userManage/detail/roleTableModal.vue"
export default component.exports